import React, { useState, useEffect } from 'react';
import client from "../../services/Api";
import moment from 'moment';
import DataTable from 'react-data-table-component';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';

function AccessLog({ location, history, params }) {
    const [logs, setLogs] = useState([])

    const query = new URLSearchParams(window.location.search);
    const user_id = query.get('user_id');

    //datatable config
    const columns = [
        {
            name: 'Data/Hora',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: true,
            width: '10%'
        },
        {
            name: 'Cliente (dispositivo)',
            selector: 'client',
            sortable: true,
            width: '10%'
        },
        {
            name: 'Versão da aplicação',
            selector: 'clientVersion',
            sortable: true,
            width: '10%'
        },
        {
            name: 'Sistema operacional',
            selector: 'clientOs',
            sortable: true,
            width: '10%'
        },
        {
            name: 'IP',
            selector: 'ip',
            sortable: true,
            width: '8%',
        },
        {
            name: 'Versão da API',
            selector: 'apiVersion',
            sortable: true,
            width: '8%',
        },
        {
            name: 'Usuário',
            selector: 'user.name',
            sortable: true,
            width: '10%'
        },
        {
            name: 'Mensagem',
            selector: 'message',
            sortable: true,
        },
    ];

    useEffect(() => {
        getBeaconHistory()
    }, []);

    async function getBeaconHistory() {
        try {
            const response = await client.get(`/api/access-log?user_id=${user_id}`);
            setLogs(response.data)
            return response;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <div className="AccessLog sidenav-margin">
            <AresNavBar />
            <SideBar />
            <div class="content">
                <div className="container-header">
                    <h1>Logs de acesso</h1>
                </div>

                <DataTable
                    columns={columns}
                    data={logs}
                    noDataComponent={
                        <span>Carregando...</span>
                    }
                    pagination={true}
                />
            </div>
        </div>
    );

}

export default AccessLog;